(ns frontend.view.user-management.view
  (:require
   [frontend.routing :as routing]
   [common.localization :as loc]
   [frontend.view.user-management.components :as components]
   [frontend.view.user-management.db :as db]
   [frontend.view.user-management.users :as users]
   [frontend.view.user-management.teams :as teams]
   [frontend.view.user-management.guest :as guest]
   [frontend.view.user-management.insider-groups :as insider-groups]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.account-invite.view :as account-invite]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [ui.components.breadcrumbs.view :as breadcrumbs]))

(defn create-team-button
  []
  (let [team-creation-disabled? (not (session/has-feature-access? :feature/team-management))]
    (when (session/is-admin?)
      [{:toolbar-button?  true
        :dropdown-action? true
        :ord              0
        :icon             :fa-plus
        :primary-button?  true
        :disabled?        team-creation-disabled?
        :on-select        (fn [_]
                            (f-entity/open-creator! :entity.type/team
                                                    {:on-ok! (fn [{:keys [close-cb!]}]
                                                               (close-cb!))}))
        :label            (loc/tr :settings.teams/toolbar-create-team)
        :tooltip-text     (when team-creation-disabled?
                            (loc/tr :settings.teams/toolbar-create-team-disabled))}])))

(defn create-insider-group-button
  []
  (when (session/insider-group-admin?)
    [{:toolbar-button?  true
      :dropdown-action? true
      :ord              1
      :icon             :fa-plus
      :primary-button?  true
      :disabled?        (not (session/has-feature-access? :feature/insider-groups))
      :on-select        (fn [_]
                          (f-entity/open-creator! :entity.type/insider-group
                                                  {:on-ok! (fn [{:keys [close-cb!]}]
                                                             (close-cb!))}))
      :label            (loc/tr :settings.teams/toolbar-create-insider-group)}]))

(defn invite-user-button
  []
  (let [active-accounts (concat (session/active-accounts nil)
                                (->> @session/all-accounts
                                     (filter :account/sys-admin?)))]
    (when (session/is-admin?)
      [{:toolbar-button?  true
        :dropdown-action? true
        :ord              2
        :icon             :fa-plus
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal! account-invite/modal-key
                                                {:existing-accounts active-accounts}))
        :label            (loc/tr :settings.team-members/toolbar-invite-user)}])))

(defn toolbar-buttons
  []
  (concat (create-team-button)
          (create-insider-group-button)
          (invite-user-button)))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (if (session/is-admin?)
                   (routing/set-view! [:account-settings :tab-key "security"])
                   (routing/set-view! [:system-settings])))}
    (loc/tr  :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (if (session/is-admin?)
      (loc/tr :settings/user-settings)
      (loc/tr :settings/insider-groups))]])


(defn page-layout
  [state _view-id content-renderer]
  [:div
   [zap-toolbar/view db/state breadcrumbs nil (toolbar-buttons)]
   [:div
    {:class "text-base-light-text
             bg-base-light"}
    (when (session/is-admin?)
      [components/tabstrip state])
    content-renderer]])

(defmethod routing/render-view :settings/users
  [{:keys [view-id]}]
  (let [state db/state
        content-renderer [users/view state]]
    [default-page-layout/view
     [page-layout state view-id
      content-renderer]]))

(defmethod routing/render-view :settings/teams
  [{:keys [view-id]}]
  (let [state db/state
        content-renderer [teams/view state]]
    [default-page-layout/view
     [page-layout state view-id
      content-renderer]]))

(defmethod routing/render-view :settings/insider-groups
  [{:keys [view-id]}]
  (let [state db/state
        content-renderer [insider-groups/view state]]
    [default-page-layout/view
     [page-layout state view-id
      content-renderer]]))

(defmethod routing/render-view :settings/guest-accounts
  [{:keys [view-id]}]
  (let [state db/state
        content-renderer (if (or (session/has-feature-access? :feature/sell-side-guest)
                                 (session/has-feature-access? :feature/buy-side-guest))
                           [guest/view state]
                           [guest/advertisement])]
    [default-page-layout/view
     [page-layout state view-id
      content-renderer]]))
